import { createContext, PropsWithChildren, useCallback, useContext, useState } from "react"
import { api } from "../../contracts";
import { HandoutResolution } from "../../contracts/handoutResolution/dto";
import { useCourse } from "../course";

type ContextHandoutResolutionData = {
    list: HandoutResolution[],
    getList: () => Promise<HandoutResolution[]>
}

const DEFAULT: ContextHandoutResolutionData = {
    list: [],
    getList: () => Promise.resolve([])
}

const HandoutResolutionContext = createContext(DEFAULT);

export const HandoutResolutionProvider = ({ children }: PropsWithChildren<any>) => {
    const { type } = useCourse();
    const [list, setList] = useState<HandoutResolution[]>([]);

    const getList = useCallback(async () => {
        const items = await api.handoutResolution.getList(type);
        setList(items);

        return items;
    }, [type]);

    return <HandoutResolutionContext.Provider
        value={{
            list,
            getList
        }}>
        {children}
    </HandoutResolutionContext.Provider>
}

export const useHandoutResolution = (): ContextHandoutResolutionData => {
    const context = useContext(HandoutResolutionContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}